export default __webpack_public_path__ + "static/media/03AW1NOV65.57af0b9c.jpg";